// extracted by mini-css-extract-plugin
export default {"tab":"header_tab__LhWw4","tab-active":"header_tab-active__wGLL4"};